// GeoStock Sync
window.geostockInventory = window.geostockInventory || {};
window.storefrontAvailability = window.storefrontAvailability || {};

// Physical-store stock check for a Storefront API storeAvailability node.
// Shopify keeps `available: true` for a pickup location that can only be served
// by transfer from Almacen Online; what changes is `pickUpTime` (the store's own
// "2 hours" becomes "2-4 days"). Same rule as pickup-availability-simple.liquid,
// and the same one cart-delivery-updater.liquid applies to cart lines.
window.storeNodeHasLocalStock = function (node) {
  if (!node || !node.available || !node.location || !node.location.name) return false;
  var name = node.location.name;
  if (name.includes('Almacen')) return false;
  if (!(name.includes('Barcelona') || name.includes('Girona'))) return false;
  var t = String(node.pickUpTime || '');
  if (/\d\s*-\s*\d/.test(t) || /day|d[ií]a|jour|giorn|tag/i.test(t)) return false;
  return true;
};

// GeoStock location entry ({ name, stock }) for a physical store with units.
window.geostockLocationHasLocalStock = function (l) {
  return !!(l && l.name && !l.name.includes('Almacen') && (l.name.includes('Barcelona') || l.name.includes('Girona')) && l.stock > 0);
};

// Name of the physical store that would ship this variant, or null when only
// the warehouse can. Barcelona has priority over Girona when both have units,
// which also decides whose local holidays apply (velodrom-holidays.js).
window.localStockOrigin = function (geoLocations, apiNodes) {
  var names = [];
  if (geoLocations) {
    geoLocations.forEach(function (l) { if (window.geostockLocationHasLocalStock(l)) names.push(l.name); });
  } else if (apiNodes) {
    apiNodes.forEach(function (n) { if (window.storeNodeHasLocalStock(n)) names.push(n.location.name); });
  }
  if (!names.length) return null;
  return names.find(function (n) { return n.includes('Barcelona'); }) || names[0];
};
if (!window._geostockShippingTimeHook) {
  window._geostockShippingTimeHook = true;
  window.applyGeostockToPickupDrawer = function (variantIdNum) {
    let hasGeostock = window.geostockInventory && window.geostockInventory[variantIdNum];
    let hasApiData = window.storefrontAvailability && window.storefrontAvailability[variantIdNum];
    if (!hasGeostock && !hasApiData) return;
    let locations = hasGeostock ? window.geostockInventory[variantIdNum] : [];
    let apiNodes = hasApiData ? window.storefrontAvailability[variantIdNum] : [];

    let hasLocalStockGlobal = false;
    let iconTick = '<svg viewBox="0 0 20 20" class="icon icon-tick" aria-hidden="true" focusable="false" style="width:20px;height:20px;flex-shrink:0"><path fill="currentColor" fill-rule="evenodd" d="M14.78 6.78a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0L4.22 10.84a.75.75 0 0 1 1.06-1.06l2.72 2.72 5.72-5.72a.75.75 0 0 1 1.06 0Z"></path></svg>';
    let iconCross = '<svg viewBox="0 0 20 20" class="icon icon-unavailable" aria-hidden="true" focusable="false" style="width:20px;height:20px;flex-shrink:0"><path fill="currentColor" fill-rule="evenodd" d="M13.28 7.78a.75.75 0 0 0-1.06-1.06l-2.22 2.22-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.22 2.22-2.22 2.22a.75.75 0 1 0 1.06 1.06l2.22-2.22 2.22 2.22a.75.75 0 0 0 1.06-1.06l-2.22-2.22 2.22-2.22Z"></path></svg>';

    // Multi-language text map for the 7 store locales
    let lang = (document.documentElement.lang || 'es').substring(0, 2);
    let availTexts = { es: 'Retiro disponible', ca: 'Recollida disponible', en: 'Pickup available', fr: 'Retrait disponible', it: 'Ritiro disponibile', de: 'Abholung verfügbar', nl: 'Ophalen beschikbaar', da: 'Afhentning mulig', pt: 'Levantamento disponível', pl: 'Odbiór osobisty dostępny', sv: 'Upphämtning tillgänglig', cs: 'Osobní odběr k dispozici' };
    let unavailTexts = { es: 'Producto en almacen logístico. Recogida en tienda disponible en 2-4 dias', ca: 'Producte en magatzem logístic. Recollida a botiga disponible en 2-4 dies', en: 'Product in logistics warehouse. Store pickup available in 2-4 days', fr: 'Produit en entrepôt logistique. Retrait en magasin disponible sous 2 à 4 jours.', it: 'Prodotto in magazzino logistico. Ritiro in negozio disponibile in 2-4 giorni', de: 'Produkt im Logistiklager. Abholung im Geschäft in 2-4 Tagen verfügbar', nl: 'Product in logistiek magazijn. Afhalen in winkel beschikbaar binnen 2-4 dagen', da: 'Produktet er på vores logistiklager. Afhentning i butikken mulig om 2-4 dage', pt: 'Produto no armazém logístico. Levantamento em loja disponível em 2-4 dias', pl: 'Produkt w magazynie logistycznym. Odbiór w sklepie możliwy za 2-4 dni', sv: 'Produkten finns på vårt logistiklager. Upphämtning i butik möjlig om 2-4 dagar', cs: 'Produkt je v logistickém skladu. Osobní odběr na prodejně možný za 2-4 dny' };
    let textAvail = availTexts[lang] || availTexts.es;
    let textUnavail = unavailTexts[lang] || unavailTexts.es;

    // Strategy: Find drawer list items by their <h3> location name (works with plain Shopify HTML)
    let drawerItems = document.querySelectorAll('.pickup-availability-list__item');

    // Text for when product is in the OTHER physical store (not warehouse)
  let otherStoreTexts = { es:'Producto en la tienda de {store}. Recogida en esta tienda en 2-4 días', ca:'Producte a la botiga de {store}. Recollida en aquesta botiga en 2-4 dies', en:'Product at the {store} store. Pickup at that store in 2-4 days', fr:'Produit au magasin de {store}. Retrait dans ce magasin sous 2 à 4 jours', it:'Prodotto nel negozio di {store}. Ritiro in quel negozio in 2-4 giorni', de:'Produkt in der Filiale {store}. Abholung in dieser Filiale in 2-4 Tagen verfügbar', nl:'Product in de winkel van {store}. Ophalen in die winkel beschikbaar binnen 2-4 dagen', da:'Produktet er i butikken i {store}. Afhentning i den butik om 2-4 dage', pt:'Produto na loja de {store}. Levantamento nessa loja em 2-4 dias', pl:'Produkt w sklepie {store}. Odbiór w tym sklepie za 2-4 dni', sv:'Produkten finns i butiken i {store}. Upphämtning i den butiken om 2-4 dagar', cs:'Produkt je na prodejně {store}. Osobní odběr na této prodejně za 2-4 dny' };

  if (drawerItems.length > 0) {
      drawerItems.forEach(item => {
        let h3 = item.querySelector('h3');
        if (!h3) return;
        let locName = h3.textContent.trim();

        // Match GeoStock location: prioritize stock > 0
        let geoLoc = locations.find(l => l.name && (l.name.includes(locName) || locName.includes(l.name)) && l.stock > 0);
        if (!geoLoc) geoLoc = locations.find(l => l.name && (l.name.includes(locName) || locName.includes(l.name)));

        // Check Storefront API data for this location (pickUpTime-aware: a
        // warehouse transfer is still `available` but is not local stock)
        let apiLoc = apiNodes.find(n => window.storeNodeHasLocalStock(n) && (n.location.name.includes(locName) || locName.includes(n.location.name)));

        // Find the status paragraph (sibling of h3)
        let statusP = item.querySelector('p.pickup-availability-preview') || item.querySelector('p.caption-large');

        if (statusP) {
          if (geoLoc && geoLoc.stock > 0) {
            // GeoStock confirms local stock
            hasLocalStockGlobal = true;
            statusP.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;color:#01751E">' + iconTick + ' ' + textAvail + '</span>';
          } else if (!hasGeostock && apiLoc) {
            // No GeoStock data but Storefront API says available
            hasLocalStockGlobal = true;
            statusP.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;color:#01751E">' + iconTick + ' ' + textAvail + '</span>';
          } else {
            // Check if the OTHER physical store has stock (GeoStock or API)
            let otherGeo = locations.find(l => l.name && (l.name.includes('Barcelona') || l.name.includes('Girona')) && l.stock > 0 && !(l.name.includes(locName) || locName.includes(l.name)));
            let otherApi = !hasGeostock ? apiNodes.find(n => window.storeNodeHasLocalStock(n) && !(n.location.name.includes(locName) || locName.includes(n.location.name))) : null;
            let otherStore = otherGeo || otherApi;
            if (otherStore) {
              let storeName = otherStore.name || (otherStore.location ? otherStore.location.name : '');
              let otherText = (otherStoreTexts[lang] || otherStoreTexts.es).replace('{store}', storeName);
              statusP.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;color:#D97706">' + iconCross + ' ' + otherText + '</span>';
            } else {
              statusP.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;color:#D97706">' + iconCross + ' ' + textUnavail + '</span>';
            }
          }
        }
      });
    } else {
      // Fallback when drawer isn't open yet
      let bcnStock = locations.find(window.geostockLocationHasLocalStock);
      if (!bcnStock) bcnStock = apiNodes.find(window.storeNodeHasLocalStock);
      if (bcnStock) hasLocalStockGlobal = true;
    }
  };

  window.addEventListener('jtcVariantLocationsLoaded', function (e) {
    if (e.detail && e.detail.variantID && e.detail.locations) {
      window.geostockInventory[e.detail.variantID] = e.detail.locations;
      // Re-trigger shipping time calculation for the active variant
      // Match against both the element attribute AND the current URL variant
      let urlVid = window.location.search.includes('variant=') ? window.location.search.split('variant=')[1].split('&')[0] : null;
      document.querySelectorAll('shipping-time').forEach(el => {
        if (el.dataset.variantId == e.detail.variantID || (urlVid && urlVid == e.detail.variantID)) {
          el.fetchVariantInfo(String(e.detail.variantID));
        }
      });
      // Trigger pickup drawer logic
      window.applyGeostockToPickupDrawer(e.detail.variantID);
    }
  });

  // Setup Mutation Observer to catch when Shopify injects the drawer via AJAX
  if (!window._geostockPickupObserver) {
    window._geostockPickupObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            let node = mutation.addedNodes[i];
            if (node.tagName === 'PICKUP-AVAILABILITY-PREVIEW' || node.tagName === 'PICKUP-AVAILABILITY-DRAWER' || (node.classList && node.classList.contains('pickup-availability-drawer-preview'))) {
              let stEl = document.querySelector('shipping-time');
              let vid = window.location.search.includes('variant=') ? window.location.search.split('variant=')[1] : (stEl ? stEl.dataset.variantId : '');
              if (vid) window.applyGeostockToPickupDrawer(vid);
            } else if (node.querySelectorAll) {
              let childDrawer = node.querySelectorAll('.pickup-availability-drawer-preview');
              if (childDrawer.length > 0) {
                let stEl = document.querySelector('shipping-time');
                let vid = window.location.search.includes('variant=') ? window.location.search.split('variant=')[1] : (stEl ? stEl.dataset.variantId : '');
                if (vid) window.applyGeostockToPickupDrawer(vid);
              }
            }
          }
        }
      });
    });
    window._geostockPickupObserver.observe(document.body, { childList: true, subtree: true });

    // Fallback: Force update the drawer when the user clicks the button to open it
    // The drawer items don't exist immediately on click - Shopify renders them ~100-300ms later
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('#ShowPickupAvailabilityDrawer') || e.target.closest('.pickup-availability-button')) {
        let stEl = document.querySelector('shipping-time');
        let vid = window.location.search.includes('variant=') ? window.location.search.split('variant=')[1].split('&')[0] : (stEl ? stEl.dataset.variantId : '');
        if (vid) {
          // Immediate attempt + retries to catch the drawer after Shopify renders it
          window.applyGeostockToPickupDrawer(vid);
          setTimeout(function () { window.applyGeostockToPickupDrawer(vid); }, 150);
          setTimeout(function () { window.applyGeostockToPickupDrawer(vid); }, 400);
          setTimeout(function () { window.applyGeostockToPickupDrawer(vid); }, 800);
        }
      }
    });
  }
}

// Shipping Time Countdown
if (!customElements.get('shipping-time')) {
  customElements.define(
    'shipping-time',
    class ShippingTimeUpdate extends HTMLElement {
      constructor() {
        super();
        // Spinner until the first Storefront response; never show a date the
        // widget hasn't computed for this variant.
        this.classList.add('is-loading');
        this.fetchVariantInfo(
          window.location.search.includes('variant=')
            ? window.location.search.split('variant=')[1]
            : this.dataset.variantId
        );
      }

      fetchVariantInfo(variantId) {
        if (!variantId) return;
        variantId = String(variantId); // Ensure string (updateShippingTime passes Number from JSON)
        this.dataset.variantId = variantId; // Keep in sync for GeoStock event matching

        const gid = 'gid://shopify/ProductVariant/' + variantId;
        const query = `
          query getProductVariant($id: ID!){
            node(id: $id) {
              ... on ProductVariant {
                id
                title
                availableForSale
                selectedOptions {
                  name
                  value
                }
                quantityAvailable
                isDeposit: metafield(namespace: "custom", key: "is_deposit") {
                  value
                }
                storeAvailability(first: 20) {
                  nodes {
                    available
                    pickUpTime
                    location {
                      name
                    }
                  }
                }
                product {
                  id
                  title
                  metafield (namespace: "custom", key: "lead_time") {
                    value
                  }
                }
              }
            }
          }
        `;

        fetch('https://velodrom-barcelona.myshopify.com/api/2024-07/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'dadc23c4598a46df4983ad35299b568d',
          },
          body: JSON.stringify({ query, variables: { id: gid } }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.data && data.data.node) {
              // Store API availability globally for drawer fallback
              let vNode = data.data.node;
              if (vNode.storeAvailability && vNode.storeAvailability.nodes) {
                let vidNum = variantId.includes('/') ? variantId.split('/').pop() : variantId;
                window.storefrontAvailability[vidNum] = vNode.storeAvailability.nodes;
                // Trigger drawer update with API data
                window.applyGeostockToPickupDrawer(vidNum);
              }
              this.updateShippingText(vNode, variantId);
            }
            this.classList.remove('is-loading');
          })
          .catch((error) => {
            this.classList.remove('is-loading');
            console.error(error);
          });
      }

      // Variant-specific supplier restock ETA, rendered server-side into
      // data-variant-etas (the metafield has no Storefront API access).
      // Returns { weeks, suffix } or null; the ETA always beats lead_time.
      getEtaInfo(variantId) {
        try {
          const map = JSON.parse(this.dataset.variantEtas || '{}');
          let vid = String(variantId || '');
          if (vid.includes('/')) vid = vid.split('/').pop();
          const iso = map[vid];
          if (!iso) return null;
          const target = new Date(iso + 'T12:00:00');
          // Whole calendar days (UTC-normalised) so a DST change between now
          // and the ETA can't add a phantom week; matches the Liquid badge.
          const now = new Date();
          const days = Math.round(
            (Date.UTC(target.getFullYear(), target.getMonth(), target.getDate()) -
              Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000
          );
          if (days <= 0) return null;
          const weeks = Math.max(1, Math.ceil(days / 7));
          const months = (this.dataset.etaMonths || '').split(',');
          const dateLabel = target.getDate() + ' ' + (months[target.getMonth()] || '') + ' ' + String(target.getFullYear()).slice(-2);
          const tpl = this.dataset.availableFromTemplate;
          const suffix = '(' + (tpl ? tpl.replace('[date]', dateLabel) : dateLabel) + ')';
          return { weeks: weeks, suffix: suffix };
        } catch (e) {
          return null;
        }
      }

      updateShippingText(data, variantId) {
        var now = new Date();
        var day = now.getDay();
        var end;
        var diffInHours;
        var diffInMinutes;

        var textValue = this.dataset.shippingTimeTodayArrival;
        var shippingTimeText = this.querySelector('#shipping-time-text');
        var shippingTimeCountdown = this.querySelector('#shipping-time-countdown');
        var shippingSteps = this.querySelector('#shipping-time-steps');
        var stDate1 = this.querySelector('#st-date-1');
        var stDate2 = this.querySelector('#st-date-2');
        var stDate3 = this.querySelector('#st-date-3');

        // Product is a deposit
        var isDeposit = data && data.isDeposit && data.isDeposit.value === 'true' ? true : false;
        var hasStock = data ? data.availableForSale : (this.dataset.hasStock === 'true');

        // Treat as pre-order (same rule as the PRE-ORDER badge): sold out but still
        // sellable (continue selling) and the product has a lead_time metafield.
        // Covers variants missing the is_deposit metafield so the widget shows the
        // lead time instead of a normal delivery date.
        var productLeadTime = data && data.product && data.product.metafield ? data.product.metafield.value : '';
        if (!isDeposit && data && hasStock && data.quantityAvailable <= 0 && productLeadTime && productLeadTime !== '0') {
          isDeposit = true;
        }

        // --- ORIGIN: which location ships this variant ---
        // GeoStock units when loaded, otherwise the pickUpTime-aware Storefront
        // check. Barcelona beats Girona; no local stock means the warehouse.
        // The origin also selects which public holidays apply to the dates.
        var localOrigin = null;
        var originLocation = 'Almacen Online';
        if (data) {
          let originVid = variantId ? (variantId.includes('/') ? variantId.split('/').pop() : variantId) : (data.id ? data.id.split('/').pop() : null);
          let geoLocations = originVid && window.geostockInventory ? window.geostockInventory[originVid] : null;
          localOrigin = window.localStockOrigin(geoLocations, data.storeAvailability ? data.storeAvailability.nodes : null);
          if (localOrigin) originLocation = localOrigin;

          // --- INJECT HIDDEN ORIGIN LOCATION PROPERTY ---
          var inputLocation = document.getElementById('origin-location-property');
          if (!inputLocation) {
            inputLocation = document.createElement('input');
            inputLocation.type = 'hidden';
            inputLocation.id = 'origin-location-property';
            inputLocation.name = 'properties[_origin_location]';
            const form = this.closest('.product') ? this.closest('.product').querySelector('form[action*="/cart/add"]') : document.querySelector('form[action*="/cart/add"]');
            if (form) {
              form.appendChild(inputLocation);
            }
          }
          if (inputLocation) {
            inputLocation.value = originLocation;
          }
        }

        var store_availabilities_available = () => {
          if (!data) return false;
          var isAvilable = isDeposit
            ? data.quantityAvailable > 0
            : !!localOrigin;
          return !!isAvilable;
        };

        // Business-day calendar for the shipping origin: weekends plus the
        // national / Catalan / local public holidays of that origin
        // (velodrom-holidays.js). Falls back to weekends only if the asset
        // failed to load.
        const H = window.VelodromHolidays || null;
        const CUTOFF_HOUR = 15;
        const isBusinessDay = (d) => H ? H.isBusinessDay(d, originLocation) : (d.getDay() !== 0 && d.getDay() !== 6);
        // After the cut-off an order would ship the next business day anyway,
        // so today's holiday no longer affects it: no "affected today" notice.
        const todayHoliday = H && now.getHours() < CUTOFF_HOUR ? H.getHoliday(now, originLocation) : null;

        const addBusinessDays = (date, daysToAdd) => {
          let daysAdded = 0;
          var resultDate = new Date(date);
          while (daysAdded < daysToAdd) {
            resultDate.setDate(resultDate.getDate() + 1);
            if (isBusinessDay(resultDate)) daysAdded++;
          }
          return resultDate;
        };

        // Same day if it can ship, otherwise the next business day
        const toBusinessDay = (date) => (isBusinessDay(date) ? new Date(date.getTime()) : addBusinessDays(date, 1));

        // Day the parcel leaves the origin: today before the cut-off on a
        // business day, otherwise the next business day.
        const getShipDate = (from) => {
          if (isBusinessDay(from) && from.getHours() < CUTOFF_HOUR) return new Date(from.getTime());
          return addBusinessDays(from, 1);
        };

        // Nothing ships today (weekend, holiday, or after cut-off with no
        // shipping day tomorrow): show a plain arrival range, no countdown.
        const tomorrow = new Date(now.getTime());
        tomorrow.setDate(tomorrow.getDate() + 1);
        const noShipToday = !isBusinessDay(now) || (now.getHours() >= CUTOFF_HOUR && !isBusinessDay(tomorrow));

        // Helper for formatting dates
        const formatWithOrdinal = (date, locale) => {
          const dayOfWeek = new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);
          const month = new Intl.DateTimeFormat(locale, { month: 'short' }).format(date);
          const day = date.getDate();
          if (locale.startsWith('en')) {
            const suffix = (day > 3 && day < 21) || day % 10 > 3 ? 'th' : ['th', 'st', 'nd', 'rd'][day % 10];
            return `${dayOfWeek}, ${day}${suffix} ${month}`;
          } else {
            return `${dayOfWeek}, ${day} ${month}`;
          }
        };

        // Shipping availability for in-store stock: the two business days
        // after the ship date (Mon 10:00 -> Tue/Wed, Thu 16:00 -> Mon/Tue,
        // holiday -> pushed past it).
        const getNextAvailableDays = (now) => {
          let shopLocale = this.dataset.shopLocale;
          const shipDate = getShipDate(now);
          return [
            formatWithOrdinal(addBusinessDays(shipDate, 1), shopLocale),
            formatWithOrdinal(addBusinessDays(shipDate, 2), shopLocale),
          ];
        };

        /*
          Shipping availability  for warehouse 
          - Before 15: add 5 -7 Business days
          - After 15: add 6 - 8 Business days
        */
        const addWarehouseDays = (now, minDays, maxDays) => {
          const minShippingDate = addBusinessDays(now, minDays);
          const maxShippingDate = addBusinessDays(now, maxDays);

          let shopLocale = this.dataset.shopLocale;

          return [
            formatWithOrdinal(minShippingDate, shopLocale),
            formatWithOrdinal(maxShippingDate, shopLocale),
          ];
        };

        var finalDateRange = '';
        let shopLocale = this.dataset.shopLocale;

        if (!hasStock) {
          // No stock and product not marked as continue selling
          if (shippingTimeText) shippingTimeText.innerHTML = '';
          if (shippingTimeCountdown) shippingTimeCountdown.innerHTML = '';
          if (shippingSteps) {
            shippingSteps.classList.remove('visible');
            shippingSteps.style.display = 'none';
          }
          var stText = this.querySelector('.shipping-time');
          if (stText) {
            stText.style.display = 'none';
          }
          this.renderHolidayNotice(null);

          let avisameContainer = this.querySelector('#shipping-avisame-container');
          if (!avisameContainer) {
            avisameContainer = document.createElement('div');
            avisameContainer.id = 'shipping-avisame-container';
            avisameContainer.style.marginTop = '10px';

            let avisameBtn = document.createElement('button');
            avisameBtn.type = 'button';
            avisameBtn.className = 'button button--secondary';
            avisameBtn.setAttribute('data-avisame-trigger', '');
            avisameBtn.style.width = '100%';
            avisameBtn.style.marginBottom = '15px';
            // Localized by the section (products.product.restock_notify.button);
            // the literal is only a fallback for a section that omits it.
            avisameBtn.textContent = this.dataset.restockButton || 'Notify me when available';

            avisameContainer.appendChild(avisameBtn);

            if (shippingSteps && shippingSteps.parentNode) {
              shippingSteps.parentNode.appendChild(avisameContainer);
            }
          }
          avisameContainer.style.display = 'block';

        } else {

          var stText = this.querySelector('.shipping-time');
          if (stText) stText.style.display = 'block';

          if (shippingSteps) shippingSteps.style.display = '';

          let avisameContainer = this.querySelector('#shipping-avisame-container');
          if (avisameContainer) avisameContainer.style.display = 'none';

          // Order confirmed: today, or the next business day when the origin
          // is closed. Shipped: the ship date (later for warehouse stock).
          let date1 = toBusinessDay(now);
          let date2 = getShipDate(now);

          // "Shipping is affected today by X" for in-stock / warehouse orders,
          // or "by X on <date>" when a holiday falls inside the delivery window
          let upcomingHoliday = null;
          if (!isDeposit && !todayHoliday && H && H.holidayBetween) {
            const lastArrival = store_availabilities_available()
              ? addBusinessDays(getShipDate(now), 2)
              : addBusinessDays(now, noShipToday ? 7 : 6);
            upcomingHoliday = H.holidayBetween(now, lastArrival, originLocation);
          }
          this.renderHolidayNotice(isDeposit ? null : todayHoliday, upcomingHoliday);

          if (!store_availabilities_available()) {
            if (isDeposit) {
              // Product is a deposit / pre-order
              textValue = this.dataset.shippingPreOrderText;
              var leadTime = data.product.metafield?.value && data.product.metafield.value !== '0' ? data.product.metafield.value : '';
              // The variant's supplier ETA is the leading source; lead_time
              // is only the fallback when Specialized reports no date.
              var etaInfo = this.getEtaInfo(variantId);
              if (etaInfo) leadTime = String(etaInfo.weeks);
              if (!leadTime) {
                shippingTimeText.innerHTML = this.dataset.shippingContactText || '';
                shippingTimeCountdown.innerHTML = '';
                finalDateRange = '';
                this.injectShippingProperty(finalDateRange);
                return;
              }
              let timeUnit = this.dataset.shippingPreOrderTime;
              if (leadTime === '1' && timeUnit.endsWith('s')) timeUnit = timeUnit.slice(0, -1);
              var etaSuffix = etaInfo ? ' ' + etaInfo.suffix : '';
              shippingTimeCountdown.innerHTML = leadTime + ' ' + timeUnit + etaSuffix;
              finalDateRange = leadTime + ' ' + timeUnit + etaSuffix;
            } else {
              // Product in the warehouse: 4-6 business days on a shipping day,
              // 5-7 when nothing leaves today (weekend, holiday, Friday late).
              textValue = this.dataset.shippingTimeWarehouseTodayArrival;
              let arrivalDates = noShipToday ? addWarehouseDays(now, 5, 7) : addWarehouseDays(now, 4, 6);
              date2 = addBusinessDays(date1, noShipToday || now.getHours() >= CUTOFF_HOUR ? 3 : 2);
              shippingTimeCountdown.innerHTML = noShipToday ? arrivalDates.join(' - ') : `<strong>${arrivalDates.join(' - ')}</strong>`;
              finalDateRange = arrivalDates.join(' - ');
            }
          } else if (noShipToday) {
            // In-store stock but the origin is closed today (weekend, public
            // holiday, or Friday after the cut-off): no "ships today" promise
            textValue = this.dataset.shippingTimeTodayArrivalWeekend;
            let arr = getNextAvailableDays(now);
            shippingTimeCountdown.innerHTML = arr.join(' - ');
            finalDateRange = arr.join(' - ');
          } else {
            // In-store stock on a shipping day: countdown to the cut-off
            if (now.getHours() < CUTOFF_HOUR) {
              // Ships today
              end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, 0, 0, 0);
            } else {
              // After the cut-off, and tomorrow is a shipping day
              end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, CUTOFF_HOUR, 0, 0, 0);
              textValue = this.dataset.shippingTimeTomorrowArrival;
            }

            var timeleft = end.getTime() - now.getTime();
            diffInHours = Math.floor(timeleft / (1000 * 60 * 60));
            diffInMinutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));

            let arr = getNextAvailableDays(now);
            shippingTimeText.innerHTML = textValue.replace(
              'AVAILABLE_DAYS',
              `<strong>${arr.join(' - ')}</strong>`
            );
            shippingTimeCountdown.innerHTML = `${diffInHours}HRS ${diffInMinutes}MIN`;
            finalDateRange = arr.join(' - ');

            if (shippingSteps) {
              shippingSteps.classList.add('visible');
              if (stDate1) stDate1.innerHTML = formatWithOrdinal(date1, shopLocale);
              if (stDate2) stDate2.innerHTML = formatWithOrdinal(date2, shopLocale);
              if (stDate3) stDate3.innerHTML = finalDateRange;
            }
            this.injectShippingProperty(finalDateRange);
            return;
          }
          shippingTimeText.innerHTML = textValue;

          if (shippingSteps && !isDeposit) {
            shippingSteps.classList.add('visible');
            if (stDate1) stDate1.innerHTML = formatWithOrdinal(date1, shopLocale);
            if (stDate2) stDate2.innerHTML = formatWithOrdinal(date2, shopLocale);
            if (stDate3) stDate3.innerHTML = finalDateRange;
          } else if (shippingSteps && isDeposit) {
            shippingSteps.classList.remove('visible');
            shippingSteps.style.display = 'none';
          }
          this.injectShippingProperty(finalDateRange);
        }
      }

      // "Shipping of this product is affected today by the X holiday", the
      // same for a holiday later in the delivery window ({ entry, date }),
      // or hidden
      renderHolidayNotice(entry, upcoming) {
        var el = this.querySelector('#shipping-time-holiday');
        if (!el) return;
        if ((!entry && !upcoming) || !window.VelodromHolidays) {
          el.hidden = true;
          el.textContent = '';
          return;
        }
        var lang = this.dataset.shopLocale || document.documentElement.lang || 'es';
        if (entry) {
          var tpl = this.dataset.shippingHolidayNotice || 'Shipping of this product is affected today by the [holiday] holiday.';
          el.textContent = tpl.replace('[holiday]', window.VelodromHolidays.holidayName(entry, lang));
        } else {
          var tplUp = this.dataset.shippingHolidayUpcoming || '[date] is a public holiday ([holiday]): your order may be delayed by one business day.';
          el.textContent = window.VelodromHolidays.upcomingNotice(tplUp, upcoming, lang);
        }
        el.hidden = false;
      }

      injectShippingProperty(dateRangeText) {
        // Every add form of the product: the main form and the mobile sticky
        // bar's footer form both submit on their own.
        const scope = this.closest('.product') || document;
        // Secret property (underscore prefix = hidden from cart UI, kept for internal/order
        // processing) and visible property (shown in cart UI to the customer).
        const names = ['properties[_Estimated Delivery]', 'properties[Estimated Delivery]'];
        scope.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          if (form.id && form.id.indexOf('product-form-installment') === 0) return;
          names.forEach((name) => {
            let input = Array.from(form.elements).find((el) => el.name === name);
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              form.appendChild(input);
            }
            input.value = dateRangeText;
          });
        });
      }
    }
  );
}
